var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonMaticIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.11 7.204c-.442-.258-1.018-.258-1.505 0l-3.454 1.975-2.347 1.288-3.453 1.975c-.443.258-1.019.258-1.506 0L3.1 10.896c-.443-.257-.753-.73-.753-1.245V6.603c0-.515.266-.988.753-1.245l2.7-1.503c.444-.258 1.02-.258 1.506 0l2.701 1.503c.443.257.753.73.753 1.245v1.975l2.347-1.331V5.272c0-.515-.266-.988-.753-1.245L7.351 1.193c-.443-.257-1.019-.257-1.506 0L.753 4.027C.266 4.284 0 4.757 0 5.272v5.71c0 .515.266.988.753 1.245l5.092 2.834c.443.257 1.018.257 1.506 0l3.453-1.932 2.347-1.331 3.454-1.932c.443-.258 1.019-.258 1.506 0l2.7 1.502c.444.258.754.73.754 1.246v3.048c0 .515-.266.987-.753 1.245l-2.701 1.546c-.443.257-1.019.257-1.506 0l-2.7-1.503c-.444-.258-.754-.73-.754-1.245V13.73l-2.347 1.33v1.976c0 .515.266.987.753 1.245l5.092 2.834c.443.257 1.019.257 1.506 0l5.092-2.834c.443-.258.753-.73.753-1.245v-5.71c0-.516-.266-.988-.753-1.245l-5.136-2.877z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 1)",
    d: "M0 0h24v21H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonMaticIcon);
export default __webpack_public_path__ + "static/media/polygon-matic-icon.c418181978f07c2298536991b90c85f3.svg";
export { ForwardRef as ReactComponent };